import { render, staticRenderFns } from "./ExpertiseArea.vue?vue&type=template&id=e5164a6c&"
import script from "./ExpertiseArea.vue?vue&type=script&lang=js&"
export * from "./ExpertiseArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports